import React, {PureComponent} from "react"
import {isAuthed} from "@irati/auth/services/whoami"
import {AuthedCheckerContext} from "../AuthedChecker"

export interface SetAuthStatusProps {
  onSuccess(): any
  onFail(): any
}

/**
 * Subscribes to the `AuthedChecker` load promise and, once resolved, invokes
 * `isAuthed()` to verify the token. Calls `onSuccess` or `onFail` accordingly.
 */
export default class SetAuthStatus extends PureComponent<SetAuthStatusProps> {
  load?: Promise<any> | null = null

  checkToken = (load?: Promise<any> | null) => {
    if (load && load !== this.load) {
      this.load = load
      load.then(() => {
        isAuthed().then(this.props.onSuccess).catch(this.props.onFail)
      })
    }

    return null
  }

  render() {
    return <AuthedCheckerContext.Consumer>{({load}) => this.checkToken(load)}</AuthedCheckerContext.Consumer>
  }
}
